var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',[_c('keep-alive',{attrs:{"include":_vm.allKeepAlive}},[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)],1),_c('transition',[(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }